import { Reducer } from 'redux'
import { ComponentLoadingActionTypes } from './actions'

export type ComponentLoadingState = Record<string, number>

export enum LoadingTypes {
  GENERAL = 'GENERAL',
  CRM_AUTH = 'CRM_AUTH',
  TABLE_MAPPING = 'TABLE_MAPPING',
  CRM_FIELDS = 'CRM_FIELDS',
  CMCM_FETCHING_ACCOUNTS = 'CMCM_FETCHING_ACCOUNTS',
  AZURE_FETCHING_ACCOUNT_DETAILS = 'AZURE_FETCHING_ACCOUNT_DETAILS',
  AZURE_DISCONNECTING_ACCOUNT = 'AZURE_DISCONNECTING_ACCOUNT',
  API_KEY_CREATE = 'API_KEY_CREATE',
  API_KEY_READ = 'API_KEY_READ',
  API_KEY_UPDATE = 'API_KEY_UPDATE',
  API_KEY_DELETE = 'API_KEY_DELETE',
  API_KEY_LOGS = 'API_KEY_LOGS',
  SLACK_CHANNELS_LOADING = 'SLACK_CHANNELS_LOADING',
  CRM_CONFIGURATION = 'CRM_CONFIGURATION',
  CRM_CONFIGURATION_AUTOFILL = 'CRM_CONFIGURATION_AUTOFILL',
  CRM_TABLES_FIELDS_DETAILS = 'CRM_TABLES_FIELDS_DETAILS',
  RESELLERS_DATA = 'RESELLERS_DATA',
  TEMPLATES = 'TEMPLATES',
  PRODUCT_INFORMATION = 'PRODUCT_INFORMATION',
  COMPANY_INFORMATION = 'COMPANY_INFORMATION',
  SUBMIT_IAM_POLICY = 'SUBMIT_IAM_POLICY',
  SUBMIT_FLYOUT_ONBOARDING = 'SUBMIT_FLYOUT_ONBOARDING',
  S3_CONNECTION = 'S3_CONNECTION',
  CRM_CONNECTION = 'CRM_CONNECTION',
  CLOUD_ACCOUNTS = 'CLOUD_ACCOUNTS',
  PRODUCTS_AND_SERVICES_CHECK = 'PRODUCTS_AND_SERVICES_CHECK',
  MARKETPLACE_INFO = 'MARKETPLACE_INFO',
  MARKETPLACE_INFO_MICROSOFT = 'MARKETPLACE_INFO_MICROSOFT',
  FLYOUT_ONBOARDING_DATA = 'FLYOUT_ONBOARDING_DATA',
  FLYOUT_OVERVIEW = 'FLYOUT_OVERVIEW',
  BUYERS_OVERVIEW = 'BUYERS_OVERVIEW',
  FLYOUT_ONBOARDING_MIGRATION_PRODUCTS = 'FLYOUT_ONBOARDING_MIGRATION_PRODUCTS',
  COSELL = 'COSELL',
  COSELL_FETCH_REFERRAL = 'COSELL_FETCH_REFERRAL',
  COSELL_FETCH_REFERRALS = 'COSELL_FETCH_REFERRALS',
  RENEW_AGREEMENT_BASED_OFFER = 'RENEW_AGREEMENT_BASED_OFFER',
  FILE_PROCESSING_LOADER = 'FILE_PROCESSING_LOADER',
  COSELL_PARTNER_CENTRAL_USERS_DATA = 'COSELL_PARTNER_CENTRAL_USERS_DATA',
  ADD_NEW_USER = 'ADD_NEW_USER',
  COSELL_DELETE_REFERRAL = 'COSELL_DELETE_REFERRAL',
  SUBMIT_FLYOUT_Offer = 'SUBMIT_FLYOUT_Offer',
  FLYOUT_PRODUCT_DETAIL = 'FLYOUT_PRODUCT_DETAIL',
  SUBMIT_FLYOUT_PRODUCT_DETAIL = 'SUBMIT_FLYOUT_PRODUCT_DETAIL',
  CLEAR_FLYOUT_PRODUCT_DETAIL = 'CLEAR_FLYOUT_PRODUCT_DETAIL',
  FLYOUT_PRODUCT_MIGRATION_PRODUCTS = 'FLYOUT_PRODUCT_MIGRATION_PRODUCTS',
  PARTNER_DATA = 'PARTNER_DATA',
  SET_SEGMENT_AND_GREEN_FIELD = 'SET_SEGMENT_AND_GREEN_FIELD',
  G2_REVIEW = 'G2_REVIEW',
  SAVE_COMPETITOR = 'SAVE_COMPETITOR',
  FETCH_COMPETITOR = 'FETCH_COMPETITOR',
  SEARCH_SEO_RANKING = 'SEARCH_SEO_RANKING',
  FETCH_KEYWORD_COMPETITOR_MAPPING = 'FETCH_KEYWORD_COMPETITOR_MAPPING',
  COSELL_FETCH_LABRA_REFERRAL_STATUS_HISTORY = 'COSELL_FETCH_LABRA_REFERRAL_STATUS_HISTORY',
  UPDATE_FLYOUT_OFFER = 'UPDATE_FLYOUT_OFFER',
  CREATE_TEMPLATE = 'CREATE_TEMPLATE',
  CREATE_LISTING_CARD = 'CREATE_LISTING_CARD',
  PRODUCT_SYNC_WITH_CLOUD = 'PRODUCT_SYNC_WITH_CLOUD',
  ACTIVATE_FREE_TRIAL = 'ACTIVATE_FREE_TRIAL',
  DEACTIVATE_FREE_TRIAL = 'DEACTIVATE_FREE_TRIAL',
  CLOUDFAAS_FTR_FORM_SECTIONS = 'CLOUDFAAS_FTR_FORM_SECTIONS',
  CLOUDFAAS_FTR_QUESTIONS = 'CLOUDFAAS_FTR_QUESTIONS',
  CLOUDFAAS_ADD_ANSWER = 'CLOUDFAAS_ADD_ANSWER',
  SUBMIT_FTR_REVIEW_FORM = 'SUBMIT_FTR_REVIEW_FORM',
  CLOUDFAAS_ASSESSMENT_LIST = 'CLOUDFAAS_ASSESSMENT_LIST',
  CLOUDFAAS_WORKLOAD_LIST = 'CLOUDFAAS_WORKLOAD_LIST',
  BUTTON_STOREFRONT_LOADING = 'BUTTON_STOREFRONT_LOADING',
  COSELL_CLOUD_SETTINGS = 'COSELL_CLOUD_SETTINGS',
  UPDATE_FLYOUT_RESELLER_AUTHORIZATION = 'UPDATE_FLYOUT_RESELLER_AUTHORIZATION',
  FETCHING_RECEIVED_RESALE_AUTHS = 'FETCHING_RECEIVED_RESALE_AUTHS',
  SYNC_RECEIVED_RESALE_AUTHS_FROM_CLOUD = 'SYNC_RECEIVED_RESALE_AUTHS_FROM_CLOUD',
  CHANNEL_OFFER_LOADING = 'CHANNEL_OFFER_LOADING',
  UPDATE_CHANNEL_OFFER = 'UPDATE_CHANNEL_OFFER',
  METRICS_LOADING = 'METRICS_LOADING',
  PROPENSITY_DATA = 'PROPENSITY_DATA',
  PROPENSITY_SCORE_ACTION = 'PROPENSITY_SCORE_ACTION',
  PROPENSITY_POLL_SUMMARY = 'PROPENSITY_POLL_SUMMARY',
  BUYER_JOURNEY_CONTRACTS = 'BUYER_JOURNEY_CONTRACTS',
  BUYER_JOURNEY = 'BUYER_JOURNEY',
  ACTIVE_RESELLER_AUTHORIZATION = 'ACTIVE_RESELLER_AUTHORIZATION',
  SAVE_NOTIFICATIONS_DATA = 'SAVE_NOTIFICATIONS_DATA',
  SUBMIT_CHANNEL_PARTNER_PRIVATE_OFFER = 'SUBMIT_CHANNEL_PARTNER_PRIVATE_OFFER',
  DRAFT_CHANNEL_PARTNER_PRIVATE_OFFER = 'DRAFT_CHANNEL_PARTNER_PRIVATE_OFFER',
  FETCHING_LINKED_PRIVATE_OFFER_VALIDATIONS = 'FETCHING_LINKED_PRIVATE_OFFER_VALIDATIONS',
  FETCH_PRODUCTS = 'FETCH_PRODUCTS',
  GENERATE_AI_LOADING = 'GENERATE_AI_LOADING',
  USAGE_LOADING = 'USAGE_LOADING',
  SAVE_WAFR_ANSWER = 'SAVE_WAFR_ANSWER',
  SAVE_AND_CONTINUE_WAFR_ANSWER = 'SAVE_AND_CONTINUE_WAFR_ANSWER',
  SAVE_MARK_NOT_APPLICABLE_CHOICES = 'SAVE_MARK_NOT_APPLICABLE_CHOICES',
  CREATE_WAFR_ASSESSMENT = 'CREATE_WAFR_ASSESSMENT',
  CREATE_FTR_ASSESSMENT = 'CREATE_FTR_ASSESSMENT',
  CLOUDFAAS_ADD_ARN = 'CLOUDFAAS_ADD_ARN',
  GET_WAFR_QUESTION = 'GET_WAFR_QUESTION',
  GET_FTR_QUESTION = 'GET_FTR_QUESTION',
  GET_LENS_REVIEW = 'GET_LENS_REVIEW',
  REFRESH_FINDINGS = 'REFRESH_FINDINGDS',
  FETCH_FINDINGS = 'FETCH_FINDINGS',
  DOWNLOAD_WAFR_REPORT = 'DONWNLOAD_WAFR_REPORT',
  GET_WAFR_QUESTION_PILLAR = 'GET_WAFR_QUESTION_PILLAR',
  SET_ASSESSMENT_FORM = 'SET_ASSESSMENT_FORM',
  GET_FINDINGS = 'GET_FINDINGS',
  GET_FTR_FINDINGS = 'GET_FTR_FINDINGS',
  DELETE_WORKLOAD = 'DELETE_WORKLOAD',
  GET_WAFR_STATUS = 'GET_WAFR_STATUS',
  CREATE_REFERRAL_TEMPLATE = 'CREATE_REFERRAL_TEMPLATE',
  DISCARD_REFERRAL_TEMPLATE = 'DISCARD_REFERRAL_TEMPLATE',
  CLONE_REFERRAL_TEMPLATE = 'CLONE_REFERRAL_TEMPLATE',
  CREATE_REFERRAL_TEMPLATE_SALESFORCE = 'CREATE_REFERRAL_TEMPLATE_SALESFORCE',
  CLONE_REFERRAL_TEMPLATE_SALESFORCE = 'CLONE_REFERRAL_TEMPLATE_SALESFORCE',
  DELETE_REFERRAL_TEMPLATE = 'DELETE_REFERRAL_TEMPLATE',
  DELETE_REFERRAL_TEMPLATE_SALESFORCE = 'DELETE_REFERRAL_TEMPLATE_SALESFORCE',
  FETCH_CURRENT_REFERRAL_TEMPLATE = 'FETCH_CURRENT_REFERRAL_TEMPLATE',
  FETCH_REFERRAL_TEMPLATES = 'FETCH_REFERRAL_TEMPLATES',
  FETCH_HUBSPOT_FIELDS = 'FETCH_HUBSPOT_FIELDS',
  SAVE_REFERRAL_TEMPLATE = 'SAVE_REFERRAL_TEMPLATE',
  FETCH_CO_SELL_MAPPING_SECTION_DATA = 'FETCH_CO_SELL_MAPPING_SECTION_DATA',
  SAVE_CO_SELL_MAPPING_SECTION_DATA = 'SAVE_CO_SELL_MAPPING_SECTION_DATA',
  EDIT_REFERRAL_TEMPLATE_NAME = 'EDIT_REFERRAL_TEMPLATE_NAME',
  UPDATE_WAFR_FLAG = 'UPDATE_WAFR_FLAG',
  SHARE_WORKLOAD = 'SHARE_WORKLOAD',
  SHARE_LIST = 'SHARE_LIST',
  DELETE_SHARED_WORKLOAD = 'DELETE_SHARED_WORKLOAD',
  FETCH_REFERRAL_FORM_DATA = 'FETCH_REFERRAL_FORM_DATA',
  GET_DEFAULT_OFFERS = 'GET_DEFAULT_OFFERS',
  FETCH_COMMENTS = 'FETCH_COMMENTS',
  COSELL_TEST_OPPORTUNITY = 'COSELL_TEST_OPPORTUNITY',
  COSELL_RESYNC_REFERRAL = 'COSELL_RESYNC_REFERRAL',
  COSELL_UPDATE_REFERRAL = 'COSELL_UPDATE_REFERRAL',
  COSELL_FETCH_AGENT_RECOMMENDATIONS = 'COSELL_FETCH_AGENT_RECOMMENDATIONS',
  COSELL_FETCH_DASHBOARD_METRICS = 'COSELL_FETCH_DASHBOARD_METRICS',
  LABRA_CHAT_FETCH_FUNDING_SUMMARY = 'LABRA_CHAT_FETCH_FUNDING_SUMMARY',
  LABRA_CHAT_FETCH_ACTION_REQUIRED = 'LABRA_CHAT_FETCH_ACTION_REQUIRED',
  DOWNLOAD_CIS_REPORT = 'DOWNLOAD_CIS_REPORT',
  SEND_MICROSOFT_CLOUDSETTINGS_DATA = 'SEND_MICROSOFT_CLOUDSETTINGS_DATA',
  GENERATE_EMBED_LOADING = 'GENERATE_EMBED_LOADING',
  SEND_MICROSOFT_SOLUTIONS_DATA = 'SEND_MICROSOFT_SOLUTIONS_DATA',
  WORKATO_LOADING = 'WORKATO_LOADING',
  DRAFT_SAVE_RESALE_AUTHORIZATION = 'DRAFT_SAVE_RESALE_AUTHORIZATION',
  SAVE_RESALE_AUTHORIZATION = 'SAVE_RESALE_AUTHORIZATION',
  GET_SINGLE_RESALE_AUTHORIZATION = 'GET_SINGLE_RESALE_AUTHORIZATION',
  UPDATE_RESALE_AUTHORIZATION = 'UPDATE_RESALE_AUTHORIZATION',
  SEND_FLYOUT_ONBOARDING_DATA = 'SEND_FLYOUT_ONBOARDING_DATA',
  GET_FLYOUT_ONBOARDING_DATA = 'GET_FLYOUT_ONBOARDING_DATA',
  GET_USERS = 'GET_USERS',
  CHECK_MICROSOFT_CONNECTION = 'CHECK_MICROSOFT_CONNECTION',
  GENERATE_AI_AGENT_LOADING = 'GENERATE_AI_AGENT_LOADING',
  LOAD_MORE_CHATS = 'LOAD_MORE_CHATS',
  GET_CONVERSATIONS = 'GET_CONVERSATIONS',
  COMBINED_FORM_LOADING = 'COMBINED_FORM_LOADING',
  SUBMIT_COMBINED_FORM = 'SUBMIT_COMBINED_FORM',
  GET_ACTION_DETAILS = 'GET_ACTION_DETAILS',
  FETCH_OPPORTUNITY_DETAILS = 'FETCH_OPPORTUNITY_DETAILS',
  FETCH_PARTNER_IQ_TABLE_DATA = 'FETCH_PARTNER_IQ_TABLE_DATA',
  FETCH_PARTNER_IQ_SEGMENTS_DATA = 'FETCH_PARTNER_IQ_SEGMENTS_DATA',
  FETCH_PARTNER_IQ_ICP_FORM_DATA = 'FETCH_PARTNER_IQ_ICP_FORM_DATA',
  FETCH_PARTNER_IQ_PROFILE_DATA = 'FETCH_PARTNER_IQ_PROFILE_DATA',
  UPDATE_PARTNER_IQ_ICP_FORM_DATA = 'UPDATE_PARTNER_IQ_ICP_FORM_DATA',
  FETCH_PARTNER_IQ_OPPORTUNITIES_REPORT = 'FETCH_PARTNER_IQ_OPPORTUNITIES_REPORT',
  FETCH_PARTNER_IQ_TABLE_REPORT = 'FETCH_PARTNER_IQ_TABLE_REPORT',
  FETCH_PARTNER_IQ_COLLAB_ROOM_PAGE_DATA = 'FETCH_PARTNER_IQ_COLLAB_ROOM_PAGE_DATA',
  FETCH_PARTNER_IQ_METRICS = 'FETCH_PARTNER_IQ_METRICS',
  SAVE_PARTNER_IQ_COLLAB_ROOM_PAGE_DATA = 'SAVE_PARTNER_IQ_COLLAB_ROOM_PAGE_DATA',
  FETCH_SYNC_CONFIGURATIONS = 'FETCH_SYNC_CONFIGURATIONS',
  FETCH_SUBSCRIBED = 'FETCH_SUBSCRIBED',
  FETCH_CRM_FIELDS = 'FETCH_CRM_FIELDS',
  FETCH_CRM_FIELD_VALUES = 'FETCH_CRM_FIELD_VALUES',
  FETCH_SALESFORCE_REFERRAL_FORM_FIELDS = 'FETCH_SALESFORCE_REFERRAL_FORM_FIELDS',
  FETCH_LABRA_FIELDS = 'FETCH_LABRA_FIELDS',
  DELETE_RESALE_AUTHORIZATION = 'DELETE_RESALE_AUTHORIZATION',
  DELETE_OFFER = 'DELETE_OFFER',
  FETCH_ALL_ICPS = 'FETCH_ALL_ICPS',
  UPDATE_ICP = 'UPDATE_ICP',
  FETCH_USER_CONFIGURATIONS = 'FETCH_USER_CONFIGURATIONS',
  UPDATE_USER_CONFIGURATIONS = 'UPDATE_USER_CONFIGURATIONS',
  POLL_SUMMARY = 'POLL_SUMMARY',
  FETCH_INFERENCE_LIMIT = 'FETCH_INFERENCE_LIMIT',
  FETCH_PRODUCTS_WITH_DIMENSIONS = 'FETCH_PRODUCTS_WITH_DIMENSIONS',
  LOAD_AVAILABLE_ACCOUNTS = 'LOAD_AVAILABLE_ACCOUNTS',
  COSELL_FETCH_AWS_PRODUCTS = 'COSELL_FETCH_AWS_PRODUCTS',
  COSELL_FETCH_SOLUTIONS_OFFERED = 'COSELL_FETCH_SOLUTIONS_OFFERED',
  UPDATE_CATEGORIES = 'UPDATE_CATEGORIES',
  FETCH_PRODUCTS_V2 = 'FETCH_PRODUCTS_V2',
  GENERATE_FEDERATED_LOGIN_LINK = 'GENERATE_FEDERATED_LOGIN_LINK',
}
export const initialState: ComponentLoadingState = {
  GENERAL: 0,
  CRM_AUTH: 0,
  TABLE_MAPPING: 0,
  CRM_FIELDS: 0,
  CMCM_FETCHING_ACCOUNTS: 0,
  AZURE_FETCHING_ACCOUNT_DETAILS: 0,
  AZURE_DISCONNECTING_ACCOUNT: 0,
  DELETE_RESALE_AUTHORIZATION: 0,
}

export type ComponentLoadingAction = {
  type: ComponentLoadingActionTypes
  payload: string
}

export const reducer: Reducer<ComponentLoadingState, ComponentLoadingAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ComponentLoadingActionTypes.START_LOADING: {
      const count = (state[action.payload] || 0) + 1
      return { ...state, [action.payload]: count }
    }
    case ComponentLoadingActionTypes.STOP_LOADING: {
      const count = (state[action.payload] || 0) - 1
      return { ...state, [action.payload]: count }
    }
    default: {
      return state
    }
  }
}
